import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import Kyquansan from './image/booking/kyquansan.png';
// Dữ liệu lịch trình chuyến đi Tà Chì Nhù
const Schedule = [
  {
    day: "Chiều Thứ 5",
    activities: [
      { time: "06:30 PM", description: "Khởi hành từ Hà Nội, bắt đầu hành trình tìm về kỳ quan mây trời Mường Hum" },
      { time: "11:30 PM", description: "Có mặt và nghỉ ngơi tại homestay ở Mường Hum - Lào Cai" },
      { 
        description: "Hãy để tiếng suối rừng đưa bạn vào giấc ngủ êm đềm. Một đêm nghỉ ngơi trọn vẹn tại vùng cao sẽ giúp bạn tái tạo năng lượng, để ngày mai rạng rỡ bắt đầu hành trình chinh phục những đỉnh cao." 
      }
    ],
  },
  {
    day: "Thứ 6 - Hành Trình Lạc Giữa Núi Muối",
    activities: [
      { time: "06:30 AM", description: "Thưởng thức bữa sáng ấm nóng giữa không khí se lạnh của vùng biên" },
      { 
        description: "Bữa sáng đầy đủ dinh dưỡng là sự quan tâm thầm lặng dành cho đôi chân của bạn. Đội ngũ sẽ giúp bạn sắp xếp hành lý gọn gàng nhất, để bạn có thể thong dong tận hưởng vẻ đẹp của đại ngàn." 
      },
      { time: "07:30 AM", description: "Trải nghiệm xe ôm bản địa xuyên qua những bản làng Tây Bắc" },
      { 
        description: "Cảm giác ngồi sau tay lái, hít căng lồng ngực mùi cỏ cây và để cơn gió thổi bay những muộn phiền phố thị. Mỗi khúc cua là một khoảnh khắc tự do, nơi bạn thấy mình gần gũi với thiên nhiên hơn bao giờ hết." 
      },
      { time: "08:30 AM", description: "Bắt đầu những bước chân đầu tiên trong câu chuyện chinh phục của bạn" },
      { 
        description: "Dưới sự dẫn dắt tận tình của các Porter, chúng ta sẽ bắt đầu vượt qua những con dốc đầu tiên. Hãy cứ thong thả, bởi mỗi bước chân bạn đi đều có chúng mình luôn sát cánh chăm sóc." 
      },
      { time: "12:00 PM", description: "Nghỉ chân dùng bữa trưa và chợp mắt giữa rừng già xanh mướt" },
      { 
        description: "Một giấc ngủ ngắn 15 phút giữa tiếng gió xào xạc sẽ giúp tâm hồn bạn được 'detox' hoàn toàn. Hãy để đại ngàn vỗ về và tiếp thêm sức mạnh cho bạn trong chặng đường tiếp theo." 
      },
      { time: "04:30 PM", description: "Cán đích lán nghỉ Núi Muối - Thiên đường săn mây" },
      { 
        description: "Đây là lúc ánh nắng cuối ngày nhuộm hồng biển mây. Hãy tận hưởng những phút giây thư thái nhất, chụp lại những khung hình lung linh tại mỏm đá hay chiếc xích đu huyền thoại trước khi màn đêm buông xuống." 
      },
      { time: "06:30 PM", description: "Dùng bữa tối đặc sản Tây Bắc bên bếp lửa hồng ấm cúng" },
      { 
        description: "Đêm 'Detox kỹ thuật số' tại Núi Muối, nơi không sóng điện thoại để chúng ta thực sự kết nối. Chăn ấm đệm êm đã sẵn sàng để bạn có một giấc ngủ ngon giữa lưng chừng trời." 
      },
    ],
  },
  {
    day: "Thứ 7 - Vinh Quang Trên Đỉnh Kỳ Quan San",
    activities: [
      { time: "06:00 AM", description: "Thức dậy đón bình minh rực rỡ nhất Tây Bắc tại Núi Muối" },
      { 
        description: "Phóng tầm mắt ngắm nhìn Fansipan, Ngũ Chỉ Sơn chìm giữa biển mây bồng bềnh. Đây chính là khoảnh khắc bạn thấy mình đang đứng trên sân thượng của thế giới, một vẻ đẹp thanh khiết và đầy cảm hứng." 
      },
      { time: "07:30 AM", description: "Bắt đầu hành trình chạm tay vào đỉnh cao Kỳ Quan San" },
      { 
        description: "Đoạn đường này mang vẻ đẹp kỳ vĩ nhưng cũng đầy thử thách. Hãy nạp đủ năng lượng và giữ một tinh thần vững vàng, bởi phần thưởng ở phía trước vô cùng xứng đáng với nỗ lực của bạn." 
      },
      { time: "12:00 PM", description: "Chạm đỉnh Kỳ Quan San (3.046m) - Niềm tự hào rạng rỡ" },
      { 
        description: "Chúc mừng bạn! Khoảnh khắc tay chạm vào chóp inox, bạn đã chiến thắng chính mình. Hãy lưu lại những bức ảnh chiến thắng đẹp nhất, bởi bạn xứng đáng với mọi lời ngợi khen trong giây phút này." 
      },
      { time: "01:30 PM", description: "Từ đỉnh quay trở về lán nghỉ Núi Muối" },
      { time: "04:30 PM", description: "Về tới lán nghỉ, nghỉ ngơi và ngắm hoàng hôn một lần nữa" },
      { time: "06:30 PM", description: "Tiệc tối liên hoan mừng chinh phục đỉnh thành công" }
    ],
  },
  {
    day: "Chủ Nhật - Lời Tạm Biệt Và Sự Chữa Lành",
    activities: [
      { time: "06:00 AM", description: "Thanh thản đón bình minh cuối cùng trên núi" },
      { time: "08:00 AM", description: "Bắt đầu hành trình xuống núi trong sự thư thái" },
      { 
        description: "Sự an toàn của bạn luôn là ưu tiên hàng đầu. Hãy siết chặt dây giày và bước đi chậm rãi. Đội ngũ sẽ luôn quan sát để đảm bảo đôi chân bạn được hỗ trợ kịp thời nhất." 
      },
      { time: "12:00 PM", description: "Dừng chân dùng bữa trưa bên thác nước trong veo" },
      { time: "01:30 PM", description: "Xe đón đoàn trở về thị xã Sapa thơ mộng" },
      { time: "03:30 PM", description: "Tận hưởng combo tắm lá thuốc Dao Đỏ & Massage phục hồi" },
      { 
        description: "Sau những ngày băng rừng, được ngâm mình trong làn nước thảo mộc thơm nồng là món quà tuyệt vời nhất cho cơ thể. Mọi đau nhức sẽ tan biến, chỉ còn lại cảm giác sảng khoái và làn da mịn màng." 
      },
      { time: "05:30 PM", description: "Bữa tiệc liên hoan tổng kết hành trình tại Sapa" },
      { time: "07:30 PM", description: "Lên xe khởi hành về lại Hà Nội" },
      { time: "11:30 PM", description: "Về tới Hà Nội. Kết thúc hành trình đầy tự hào và những kỷ niệm vô giá." }
    ],
  }
];

const KyQuanSanSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-ta-chi-nhu.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
        <p className='block text-xl font-sans italic px-5 py-2'>🐉 Kỳ Quan San (Bạch Mộc) – Nơi "Sống Lưng Khủng Long" Chạm Thiên Đường</p>
        <p className='block text-lg font-sans italic px-5 py-2'>
          Kỳ Quan San (Bạch Mộc Lương Tử) – ngọn núi cao 3.046 mét, được ví là đỉnh cao của mọi chuyến phiêu lưu 
          trekking tại Việt Nam. Đây là nơi duy nhất bạn được trải nghiệm cảm giác bước đi trên
           “Sống Lưng Khủng Long” (đoạn núi nối giữa đỉnh cũ và đỉnh mới) – một dải đất chênh vênh, 
           tráng lệ, được bao phủ bởi đại dương mây bồng bềnh 360 độ.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Cảnh hùng vĩ khi nhìn từ sống lưng Kỳ Quan San
        </p>
        <img src={Kyquansan} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {Schedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default KyQuanSanSchedule;